<template>
<div id="row">
    <div class="ibox float-e-margins">
        <div class="ibox-title">
            <!-- 查询条件 -->
            <el-form :inline="true" :model="formInline" class="demo-form-inline" ref="form1" name="form2">
                <el-form-item :label="item.label"  v-for="(item,num) in codeComs" :key="num">
                    <component :is="item.component" :value.sync="item.value"></component>
                </el-form-item>
            </el-form>
            <el-button class="btn-primary" @click="submit()">提交</el-button>
        </div>
        <!-- 查询条件 -->
        <div class="ibox-content">
            <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline" role="grid">
                <!-- 操作按钮 -->
                <div class="setBut" v-for="item in operation" v-show="operation.length>0">
                    <el-button>{{item.name}}</el-button>
                </div>
                <div>
                     <!-- 表头 -->
                    <div class="titleHead" :model="titleHead" v-show="titleHead!=''">{{titleHead}}</div>
                    <!-- 表头分标题 -->
                    <div class="setCaption" v-show="captionShow">
                        <div class="leftCaption" :model="leftCaption">{{leftCaption}}</div>
                        <div class="rightCaption" :model="rightCaption">{{rightCaption}}</div>
                    </div>
                    <el-table ref="multipleTable" id="tableList" :span-method="objectSpanMethod" class="table-bordered" role="grid" :data="tableData" v-loading="tableLoading" element-loading-text="拼命加载中" bordertooltip-effect="dark" style="width: 100%;test-align:center">
                        <template v-for='item in tableHeader'>
                            <el-table-column v-if="item.subNodes!=undefined&&item.subNodes.length>0" :label="item.name">
                                <template v-for='data in item.subNodes'>
                                    <el-table-column v-if="data.subNodes!=undefined&&data.subNodes.length>0" :label="data.name">
                                        <template v-for='list in data.subNodes'>
                                            <el-table-column v-if="list.subNodes!=undefined&&list.subNodes.length>0" :label="list.name">
                                                <template v-for='th in list.subNodes'>
                                                    <el-table-column :prop="th.id" :label="th.name"></el-table-column>
                                                </template>
                                            </el-table-column>
                                            <el-table-column v-else :prop="list.id" :label="list.name"></el-table-column>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-else :prop="data.id" :label="data.name"></el-table-column>
                                </template>
                            </el-table-column>
                            <el-table-column v-else :prop="item.id" :label="item.name"></el-table-column>
                        </template>
                    </el-table>
                    <div class="lookDel">
                        <el-button type="text" @click="lookDel($event)" style="font-size: 16px;font-weight: bold;">幼儿园明细<i class="el-icon-arrow-up"></i></el-button>
                    </div>
                    <el-table class="table-bordered" role="grid" :span-method="spanMethod" v-show="tableDataDel!=''" :data="tableDataDel" v-loading="tableLoading" element-loading-text="拼命加载中" bordertooltip-effect="dark" style="width: 100%">
                       <template v-for='item in tableHeaderDel'>
                            <el-table-column v-if="item.subNodes!=undefined&&item.subNodes.length>0" :label="item.name">
                                <template v-for='data in item.subNodes'>
                                    <el-table-column v-if="data.subNodes!=undefined&&data.subNodes.length>0" :label="data.name">
                                        <template v-for='list in data.subNodes'>
                                            <el-table-column v-if="list.subNodes!=undefined&&list.subNodes.length>0" :label="list.name">
                                                <template v-for='th in list.subNodes'>
                                                    <el-table-column :prop="th.id" :label="th.name"></el-table-column>
                                                </template>
                                            </el-table-column>
                                            <el-table-column v-else :prop="list.id" :label="list.name"></el-table-column>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-else :prop="data.id" :label="data.name"></el-table-column>
                                </template>
                            </el-table-column>
                            <el-table-column v-else :prop="item.id" :label="item.name"></el-table-column>
                        </template>
                    </el-table>
                    <div v-show="description!=''" style="margin-top: 20px;">{{description}}</div>
                </div>
            </div>
        </div>
        
    </div>
</div>

</template>
<script>
import Vue from 'vue'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import dateCom from './codeCom/date'
import yearCom from './codeCom/year'
import conditionCom from './codeCom/condition'
import yearAndclassByCityAndOrgCom from './codeCom/yearAndclassByCityAndOrg'
import yearAndClassCom from './codeCom/yearAndClass'
import inputCom from './codeCom/input'
import lapse_toCom from './codeCom/lapse_to'
import diseaseCom from './codeCom/disease'
import crbCom from './codeCom/crb'
import treatmethodCom from './codeCom/treatmethod'
import yearAndOldOrClassCom from './codeCom/yearAndOldOrClass'
import sexCom from './codeCom/sex'
import geanCom from './codeCom/gean'
import jbjzCom from './codeCom/jbjz'
import yearGradeAndClassCom from './codeCom/yearGradeAndClass'
import monthCom from './codeCom/month'
import caseCom from './codeCom/case'
import yearAndBatchCom from './codeCom/yearAndBatch'
import tjtypeCom from './codeCom/tjtype'
import fourlinkCom from './codeCom/fourlink'
import drugNameCom from './codeCom/drugName'
import singleDataCom from './codeCom/singleData'
import trainFromCom from './codeCom/trainFrom'
import trainerCom from './codeCom/trainer'
import exportCom from './codeCom/export'

window.getId = new Vue()

export default {
  name: 'app',
  components: {
      dateCom,
      yearCom,
      conditionCom,
      yearAndclassByCityAndOrgCom,
      yearAndClassCom,
      inputCom,
      lapse_toCom,
      diseaseCom,
      crbCom,
      treatmethodCom,
      yearAndOldOrClassCom,
      sexCom,
      geanCom,
      jbjzCom,
      yearGradeAndClassCom,
      monthCom,
      caseCom,
      yearAndBatchCom,
      tjtypeCom,
      fourlinkCom,
      drugNameCom,
      singleDataCom,
      trainFromCom,
      trainerCom,
      exportCom
    },
  data () {
      return {
            // 对象属性
          codeComs: [
                {component: 'dateCom', label: '日期：', value: '', name: 'date'},
                // {component:"yearCom",label:'学年',value:'2012',name:'year'},
              {component: 'yearAndclassByCityAndOrgCom',
                value: [
                        {label: '市', value: '', name: 'provinceID'},
                        {label: '区县', value: '', name: 'cityID'},
                        {label: '幼儿园', value: '', name: 'orgID'}
                    ]
              },
                {component: 'conditionCom', label: '状态：', value: '2', name: 'status'},
                {component: 'diseaseCom', label: '疾病：', value: '', name: 'orgDiseaseID'},
              {component: 'yearAndClassCom',
                value: [
                        {label: '学年', value: '', name: 'yearID'},
                        {label: '班级', value: '', name: 'classID'}
                    ]
              }
                // // {component:"inputCom",label:'姓名：',value:'',name:'childName'},
                // // {component:"inputCom",label:'使用人：',value:'',name:'name'},
                // // {component:"lapse_toCom",label:'转归：',value:'',name:'outcomeType'},

                // // {component:"crbCom",label:'传染病种类：',value:'',name:'orgDiseaseID'},
                // // {component:"treatmethodCom",label:'处理方法：',value:'',name:'treatmethod'},
                // {component:"yearAndOldOrClassCom",label:'',value:'',name:'yearAndOldOrClass'},
                // // {component:"sexCom",label:'性别：',value:'',name:'sex'},
                // // {component:"geanCom",label:'体弱儿名称：',value:'',name:'orgDiseaseID'},
                // // {component:"jbjzCom",label:'疾病：',value:'',name:'orgDiseaseID'},
                // {component:"yearGradeAndClassCom",label:'',value:'',name:'yearGradeAndClass'},
                // // {component:"monthCom",label:'月份：',value:'',name:'month'},
                // // {component:"caseCom",label:'个案状态：',value:'2',name:'isClose'},
                // {component:"yearAndBatchCom",label:'',value:'',name:'yearAndBatch'},
                // {component:"tjtypeCom",label:'',value:'',name:'tjtype'},
                // {component:"fourlinkCom",label:'',value:'',name:'fourlink'},
                // // {component:"drugNameCom",label:'药品名称：',value:'',name:'drugName'},
                // // {component:"singleDataCom",label:'检查时间：',value:'',name:'date'},
                // // {component:"trainFromCom",label:'形式：',value:'',name:'trainFrom'},
                // {component:"trainerCom",label:'培训人：',value:'',name:'trainer'}
            ],
          operation: [// 操作按钮
                // {component:"exportCom",id:'export',value:"导出"}
            ],
          titleHead: '表名', // 表名
          leftCaption: '', // 左分标题
          rightCaption: '', // 右分标题
          tableHeader: '', // 表头
          tableData: '', // 表格数据
          tableHeaderDel: '', // 详情表表头
          tableDataDel: '', // 详情表数据
          captionShow: false, // 是否有题注
          description: '', // 备注
          spanList: '',
          num: 0,
          numDel: 0
        }
    },
  methods: {
      getCondition: function () {
          let result = new Array()
          this.codeComs.forEach(item => {
              let condItem = new Object()
              if (!(item.value instanceof Array)) {
                  condItem[item.name] = item.value
                } else{
                  item.value.forEach(i => {
                      condItem[i.name] = i.value
                    })
                }
              result.push(condItem)
            })
            return result
        },
      submit: function () {
            // 循环遍历集合，进行条件拼接
          var condition = this.getCondition()
            // 把所有显示的查询条件字段名放在一个对象中
          var params = new Object
            for (var i = 0; i < condition.length; i++) {
              for (var obj in condition[i]) {
                  params[obj] = condition[i][obj]
                }
            }
          console.log(params)
            //  var a=this.$refs[formName].ruleForm
        },
      getOperation: function () {
        },
      lookDel (event) {
          var dom = event.target.children[0]
          var param = {
              reportID: 'childInjuryQueryImplService',
              params: {
                  cityID: '',
                  countryID: '',
                  orgID: '',
                  yearNum: '2017'
                }
            }
          if (dom.className == 'el-icon-arrow-up') { // 展开
              this.getdata('statistics/buildDetail.do', param, 2)
                dom.className = 'el-icon-arrow-down'
            }else { // 收起
              this.tableDataDel = '';
              dom.className = 'el-icon-arrow-up'
            }
        },
      getdata (url, param, type) {
          var self = this
            api.post(config.host + url, param).then((data) => {
              if (data.success == true) {
                  var table = data.body.table
                    if (type == 1) {
                      self.num = 0
                        self.tableHeader = table.head.elements
                      self.tableData = table.data.dataList
                      self.operation = data.body.operation.elements
                      self.description = table.data.description == undefined ? '':table.data.description
                      self.spanList = table.data.spanList
                        if (table.data.name != '' && table.data.name != undefined) {
                          self.titleHead = table.data.name
                        }
                      if (table.data.leftCaption != undefined && table.data.rightCaption != undefined) {
                          self.captionShow = true
                        }
                      if (table.data.leftCaption) {
                          self.leftCaption = table.data.leftCaption
                        }
                      if (table.data.rightCaption) {
                          self.rightCaption = table.data.rightCaption
                        }
                    } else if (type == 2) {
                      self.numDel = 0
                        self.tableHeaderDel = table.head.elements
                      self.tableDataDel = table.data.dataList
                      self.spanListDel = table.data.spanList
                    }
                }
            })
        },
      objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
          var self = this
            var rowNum = rowIndex
            if (this.spanList != undefined && this.spanList != '') {
              if (rowNum < (this.spanList[self.num].rowSpan * (self.num + 1))) {
                  if (columnIndex == this.spanList[self.num].colIndex) {
                      if (rowNum % this.spanList[self.num].rowSpan === 0) {
                          return {
                              rowspan: this.spanList[self.num].rowSpan,
                              colspan: this.spanList[self.num].colSpan
                            }
                        } else {
                          return {
                              rowspan: 0,
                              colspan: 0
                            }
                        }
                    }
                } else if (self.num < (this.spanList.length - 1)) {
                  self.num++
                }
            }
        },
      spanMethod ({ row, column, rowIndex, columnIndex }) {
          var self = this
            var rowNum = rowIndex
            if (this.spanListDel != undefined && this.spanListDel != '') {
              if (rowNum < (this.spanListDel[self.numDel].rowSpan * (self.numDel + 1))) {
                  if (columnIndex == this.spanListDel[self.numDel].colIndex) {
                      if (rowNum % this.spanListDel[self.numDel].rowSpan === 0) {
                          return {
                              rowspan: this.spanListDel[self.numDel].rowSpan,
                              colspan: this.spanListDel[self.numDel].colSpan
                            }
                        } else {
                          return {
                              rowspan: 0,
                              colspan: 0
                            }
                        }
                    }
                } else if (self.numDel < (this.spanListDel.length - 1)) {
                  self.numDel++
                }
            }
        }
    },
  beforeCreate: function () {

        // 创建前状态
    },
  created: function () {
        // 根据reportID获取当前报表的相关查询条件和信息
      console.log(this.$route.params.reportID)
        // 根据获取到的相关查询条件信息进行查询条件的组件获取并渲染
        // 初始化渲染报表的表头和表体区域
        // 创建完毕状态
      var self = this
        var param = {
          reportID: 'childInjuryQueryImplService'
        }
      this.getdata('statistics/buildReport.do', param, 1)
    },
  beforeMount: function () {

        // 挂载前状态

    },
  mounted: function () {

        // 挂载结束状态

    },
  beforeUpdate: function () {

        // 更新前状态

    },
  updated: function () {

        // 更新完成状态

    },
  beforeDestroy: function () {

        // 销毁前状态

    },
  destroyed: function () {

        // 销毁完成状态

    }
}
</script>

<style>
.setBut{
    padding:0 10px 15px;
    margin-bottom:15px;
    border-bottom: 1px solid #ddd;
}

.lookDel{
    text-align: center;
    padding: 10px;
}

.titleHead{
    width: 100%;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    padding-bottom: 15px;
}

.setCaption{
    height:40px;
    line-height:40px;
    font-size:14px;
    padding:0 20px 0 20px;
}
.leftCaption{
    display: inline-block;
    float: left;
    font-size:14px;
}
.rightCaption{
    display: inline-block;
    float: right;   
}
</style>



// WEBPACK FOOTER //
// src/components/reports/reportsDetail.vue?1eff0933